import { Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { IMessage } from '../success-snack-bar/success-snack-bar.component';

@Component({
  selector: 'app-error-snack-bar',
  imports: [MatIcon],
  templateUrl: './error-snack-bar.component.html',
  styleUrl: './error-snack-bar.component.css',
})
export class ErrorSnackBarComponent {
  data = inject<IMessage>(MAT_SNACK_BAR_DATA);
  private readonly snackBarRef =
    inject<MatSnackBarRef<ErrorSnackBarComponent>>(MatSnackBarRef);

  dismissSnackBar() {
    this.snackBarRef.dismiss();
  }
}
